import { BX_MAP_UPDATE_EXPERIMENT } from 'shared/map-search/constants/config';
import { selectExperiment } from 'shared/map-search/selectors/experiments';
import { IExperiment } from 'shared/map-search/types/experiments';
import { TUser } from 'shared/map-search/types/user';

import { TTrackingUser } from '../../types/cianAnalyticsPageViewObject';

interface IGetTrackingUserParams {
  user: TUser;
  regionId?: null | number;
  experiments: IExperiment[];
}

export const getTrackingUser = ({ user, regionId, experiments }: IGetTrackingUserParams): TTrackingUser => {
  const mapUpdateExperimentUserGroup = getMapUpdateExperimentUserGroup(experiments);

  const extra = { defaultRegionId: regionId, [BX_MAP_UPDATE_EXPERIMENT]: mapUpdateExperimentUserGroup };

  if (user && user.isAuthenticated) {
    return {
      userId: user.userId,
      extra,
    };
  }

  return {
    extra,
  };
};

/**
 * @description
 * Функция для определения группы пользователя для эксперимента BX_MAP_UPDATE_EXPERIMENT.
 * Будет удалена после завершения эксперимента
 */
function getMapUpdateExperimentUserGroup(experiments: IExperiment[]): string {
  const mapUpdateExperiment = selectExperiment(experiments, BX_MAP_UPDATE_EXPERIMENT);

  const userGroup = mapUpdateExperiment?.groupName || 'A';

  return userGroup.toLowerCase();
}
